module.exports = __webpack_public_path__ + "img/3.f3630810.png";